import EventBusyIcon from "@mui/icons-material/EventBusy";
import { Stack, Typography } from "@mui/material";
import React from "react";

import EnvironmentConfiguration from "../../constants/EnvironmentConfiguration";
import EscapePhone from "../../V2/App/Components/EscapePhone";
import ViewWrapper, { ViewWrapperIconProps } from "./ViewWrapper";

export interface NoAvailabilityViewProps {
  /** The name of the patient whom has already completed this link. */
  patientFirstName: string;
}

/** The web page shown when the user has a valid link but the link has already been completed. */
const NoAvailabilityView: React.FC<NoAvailabilityViewProps> = ({ patientFirstName }) => {
  return (
    <ViewWrapper
      header={`Sorry ${patientFirstName}.`}
      subheader="There are no available appointment times on the calendar."
      icon={<EventBusyIcon {...ViewWrapperIconProps} />}
      hideNeedHelpDialog
    >
      <Stack alignItems="center" justifyContent="center" spacing={3} sx={{ width: "100%" }}>
        <Typography variant="h5">Still Interested?</Typography>
        <Typography variant="body1">
          Please contact us at <EscapePhone phoneNumber={EnvironmentConfiguration.escapePhoneNumber} /> to schedule a
          new consultation.
        </Typography>
      </Stack>
    </ViewWrapper>
  );
};

export default NoAvailabilityView;
